import  { useEffect, useState } from "react";
import ViewFile from "./ViewFile";
import { toast } from "react-toastify";
import { mediaExtensions } from "../constant/constant";
import Lottie from "lottie-react";
import FileTransfer from "../../assets/lottie/file-transfer.json";
import { classNames } from "../../helpers/classNames";

const MultiFileUploader = ({
  handleFile = () => {},
  progress = 0,
  selectedFile,
  placeholder,
  mainClass,
}) => {
  const [files, setFile] = useState([]);
  const [message, setMessage] = useState();

  const handleFileChange = (e) => {
    setMessage("");
    const fileList = Array.from(e.target.files);
    e.target.value = null;

    // Get all allowed extensions from mediaExtensions
    const allowedExtensions = Object.values(mediaExtensions).flat();

    let newFiles = [...files];

    fileList.forEach((file) => {
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        const isDuplicate = newFiles.some(
          (existingFile) => existingFile.name === file.name
        );

        if (!isDuplicate) {
          newFiles.push(file);
        } else {
          toast.warning(`File "${file.name}" is already selected.`);
        }
      } else {
        setMessage(`"${file.name}" has an unsupported file type.`);
        toast.warning(`"${file.name}" is not an allowed file type.`);
      }
    });

    setFile(newFiles);
  };

  useEffect(() => {
    if (files?.length) {
      handleFile(files);
    }
  }, [files]);

  function removeHandler(fileIndex) {
    const updatedFiles = files.filter((_, index) => index !== fileIndex);
    setFile(updatedFiles);
  }

  useEffect(() => {
    if (!selectedFile) {
      setFile([]);
    }
  }, [selectedFile]);

  return (
    <>
      <div className="relative">
        <div className="w-full flex justify-center relative space-y-1">
          <div
            className={classNames(
              `w-full h-72 relative overflow-hidden items-center rounded-3xl cursor-pointer border-2 border-gray-300 border-dashed py-20 mt-3 bg-background-light`,
              mainClass
            )}
          >
            <input
              type="file"
              multiple
              onChange={(e) => {
                handleFileChange(e);
              }}
              className="h-full w-full bg-green-200 opacity-0 z-10 absolute top-0 left-0 cursor-pointer"
              name="files[]"
            />
            <div className="h-full w-full z-1 flex flex-col justify-center items-center">
              <div className="w-2/12 h-2/12 mx-auto">
                <Lottie animationData={FileTransfer} loop={true} />
              </div>
              <div className="space-y-4 -mt-4 w-full flex flex-col items-center">
                <div className="font-semibold text-lg text-secondary text-center">
                  {placeholder ||
                    "Drag your documents, photos or videos here to start uploading"}
                </div>
                <div className="flex items-center justify-center gap-3 px-10 w-2/3">
                  <div className="bg-gray-300 h-[1px] w-5/12"></div>
                  <span className="text-slate-60 text-secondary uppercase text-sm font-medium">
                    Or
                  </span>
                  <div className="bg-gray-300 h-[1px] w-5/12"></div>
                </div>
              </div>
              <div className="flex items-center justify-center space-x-0 lg:space-x-4 ">
                <label
                  htmlFor="fileInput"
                  className="cursor-pointer flex gap-2 items-center justify-center w-32 h-10 flex-shrink-0 bg-primary border border-dashed border-primary text-white rounded-md hover:bg-secondary transition duration-300 text-sm"
                >
                  <i className="fa-regular fa-upload"></i> Browse for file
                </label>
              </div>
            </div>
          </div>
        </div>
        {/* 
        {message && (
          <div className="flex justify-center items-center text-xs mb-1 text-red-500">
            {message}
          </div>
        )} */}
        <div className="mt-5 max-h-[calc(100vh-500px)] overflow-y-auto">
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {files.map((file, i) => (
              <ViewFile
                key={file?.name + i}
                file={file}
                progress={progress || 0}
                removeHandler={() => removeHandler(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MultiFileUploader;
